import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  FormControl,
  IconButton,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";
import CloseIcon from "@mui/icons-material/Close";

const NuevoCorreoModal = ({ open, onClose, onSubmit }) => {
  const [nombreDestinatario, setNombreDestinatario] = useState("");
  const [correoDestinatario, setCorreoDestinatario] = useState("");
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  useEffect(() => {
    fetchClientes();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ 
      nombreDestinatario, 
      correoDestinatario, 
      clienteId: clienteSeleccionado ? clienteSeleccionado.id : null 
    });
    setNombreDestinatario("");
    setCorreoDestinatario("");
    setClienteSeleccionado(null);
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6">Nuevo correo</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Nombre destinatario"
            value={nombreDestinatario}
            onChange={(e) => setNombreDestinatario(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Correo destinatario"
            value={correoDestinatario}
            onChange={(e) => setCorreoDestinatario(e.target.value)}
            margin="normal"
            type="email"
            required
          />
          <FormControl fullWidth sx={{mt: 2}}>
            <Autocomplete
              noOptionsText="No hay opciones disponibles"
              options={clientes}
              getOptionLabel={(option) => option.nombre || ''}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" />
              )}
              value={clienteSeleccionado}
              onChange={(event, newValue) => {
                setClienteSeleccionado(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
            >
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default NuevoCorreoModal;